<template>
  <div>
    <div class="y-fs-16 y-fw-700 y-fl-32">
      集运订单请直接发货至集运仓库<span class="y-fs-12 y-fc-999">（详细信息请<a class="y-fc-4C84FF" href="https://mms.pinduoduo.com/daxue/detail?courseId=5460" target="_blank">查看课程</a>）</span>
    </div>
    <div class="y-mt-5 y-fs-14 y-fw-700">
      <i class="el-icon-check y-fc-3bb950 y-fs-16"></i>
      商家直接发货至集运仓库
    </div>
    <div class="y-pl-20">
      订单收件人信息已替换为集运仓地址，打单发货时请<span class="y-fc-FE8732">复制完整的收货信息（包括地址后识别码）</span>
    </div>
    <div class="y-mt-5 y-fs-14 y-fw-700">
      <i class="el-icon-check y-fc-3bb950 y-fs-16"></i>
      集运仓库二次发货至消费者
    </div>
    <div class="y-pl-20">
      集运仓入库后将重新打包，并将包裹转运至消费者实际地址
    </div>
    <div class="y-mt-5 y-fs-14 y-fw-700">
      <i class="el-icon-check y-fc-3bb950 y-fs-16"></i>
      消费者信息/中转状态/二段轨迹信息查看请移步至商家后台
    </div>
    <div class="y-pl-20">
      若您需要查看消费者信息/中转状态/最新二段物流轨迹，请前往拼多多商家后台<a class="y-fc-4C84FF" :href="'https://mms.pinduoduo.com/orders/detail?type=4399&sn=' + orderId" target="_blank">查看订单详情</a>
    </div>
  </div>
</template>
<script>
export default {
  props: ['orderId']
}
</script>
